import React from 'react'
const Card_1 = (props) => {
    const {icon, title, subTitle, isClick} = props;
    return (
        <div className={`process-item h-100 p-10 ${isClick && 'cursor-pointer'}`} onClick={props.cardOnClick}>
            <div className="icon">
                <img src={icon} alt="icon" className="w-30" />
            </div>
            <div className="title-wrap">
                <h3 className="title fs-1 text-grad-2">{title}</h3>
            </div>
            <div className="text-wrapper">
                <p className="text fs-3 text-gray-800">
                    {subTitle}
                </p>
            </div>
        </div>
    )
}

export {Card_1}